export const time = {
  state: {
    init: {
      description:
        'Routing waktu adalah elemen sirkuit yang memungkinkan Anda membuat kondisi pengalihan panggilan, bergantung pada kondisi waktu yang ditentukan. Bergantung pada pemenuhan kondisi, panggilan akan diarahkan lebih jauh di sepanjang salah satu jalur skema routing.'
    },
    add_schedule: {
      title: 'Pilih Jadwal Waktu',
      title_edit: 'Ganti Jadwal',
      required: 'Jadwal tidak dipilih'
    }
  }
};
